<td [attr.colspan]="colspan">
	{{ translationKey | translate }}
</td>
